import React from "react";
import { graphql } from "gatsby";
import { PageBuilderSubscribeToNewsletterFragment } from "types/graphql-types";
import SubscribeToNewsletter from "components/SubscribeToNewsletter/SubscribeToNewsletter";
import { useLanguage } from "src/utils/localization/languages/I18nContext";
import { getPrivacyPolicyUrl } from "src/urls/subscribe_newsletter_urls";

type PageBuilderSubscribeToNewsletterProps =
  PageBuilderSubscribeToNewsletterFragment;

const PageBuilderSubscribeToNewsletter: React.FC<
  React.PropsWithChildren<PageBuilderSubscribeToNewsletterProps>
> = ({ defaultContent, formDisclaimerContent, offersPagePath }) => {
  const language = useLanguage();

  return (
    <SubscribeToNewsletter
      title={defaultContent?.heading?.title?.localized || ""}
      content={defaultContent?.heading?.content?.localized}
      backgroundImage={defaultContent?.backgroundImage}
      formName="SubscribeToNewsletterSection"
      formDisclaimerContent={formDisclaimerContent}
      privacyPolicyUrl={getPrivacyPolicyUrl(language.code)}
      offerPageUrl={offersPagePath}
    />
  );
};

export default PageBuilderSubscribeToNewsletter;

// eslint-disable-next-line import/no-unused-modules
export const fragments = graphql`
  fragment PageBuilderSubscribeToNewsletter on SanitySubscribeToNewsletter {
    _key

    defaultContent {
      heading {
        title {
          localized
        }
        content {
          localized
        }
      }
      backgroundImage {
        ...ImageWithAlt
      }
    }

    formDisclaimerContent: formDisclaimer {
      ...FormDisclaimer
    }

    offersPagePath
  }
`;
